// extracted by mini-css-extract-plugin
export var box = "AnchorMenu-module--box--410cd";
export var box_md = "AnchorMenu-module--box_md--c7401";
export var box_xmd = "AnchorMenu-module--box_xmd--8c6a7";
export var box_flex = "AnchorMenu-module--box_flex--824f0";
export var box_lg = "AnchorMenu-module--box_lg--f6d11";
export var box_sm = "AnchorMenu-module--box_sm--d34f4";
export var box_outer = "AnchorMenu-module--box_outer--deb9c";
export var box_whiteBg = "AnchorMenu-module--box_white-bg--e1fe3";
export var box_noMarginBottom = "AnchorMenu-module--box_no-margin-bottom--875ce";
export var box_noPadding = "AnchorMenu-module--box_no-padding--a00ed";
export var box_outerGray = "AnchorMenu-module--box_outer-gray--ddc47";
export var box_dark = "AnchorMenu-module--box_dark--4238d";
export var box_zIndex = "AnchorMenu-module--box_z-index--2cac5";
export var box_zIndex6 = "AnchorMenu-module--box_z-index-6--3e5b2";
export var box_eventsWithLine = "AnchorMenu-module--box_events-with-line--2699b";
export var box_featuresAo = "AnchorMenu-module--box_features-ao--38fc9";
export var box_verticalPaddings = "AnchorMenu-module--box_vertical-paddings--af117";
export var clearP = "AnchorMenu-module--clearP--9576e";
export var clearP_vc = "AnchorMenu-module--clearP_vc--4d04b";
export var linkWrapper = "AnchorMenu-module--linkWrapper--bc9e6";
export var mobileMenu = "AnchorMenu-module--mobileMenu--ad846";
export var link = "AnchorMenu-module--link--e0765";
export var current = "AnchorMenu-module--current--a9b56";
export var fadeInAnimation = "AnchorMenu-module--fadeInAnimation--5f735";
export var placeHolderShimmer = "AnchorMenu-module--placeHolderShimmer--1836a";